import { useEffect } from 'react';

import tradingDataStore from 'lib/stores/tradingData';
import { useRouter } from 'next/router';
import useTradingAccount from './useTradingAccount';

const useGetPortfolioData = (
  symbol: string,
  refetch = true,
  fromAll = false,
  dayTrade = false,
) => {
  const router = useRouter();
  const { isRealTrading, isVirtualTrading } = useTradingAccount();
  const {
    portfolio: {
      data: { result: realList },
    },
    portfolioDetail: { data: detail },
    portfolioDetailDayTrade: { data: detailDayTrade },
    getPortfolio,
    getPortfolioDetail,
  } = tradingDataStore();

  let data = null;

  if (symbol) {
    if (isRealTrading && symbol) {
      if (fromAll) {
        data = realList.find((l) => l.symbol === symbol);
      } else {
        data = dayTrade ? detailDayTrade : detail;
      }
    } else if (isVirtualTrading) {
      data = realList.find((l) => l.symbol === symbol);
    }
  } else {
    data = realList;
  }

  useEffect(() => {
    if (refetch) {
      if (isRealTrading && !symbol) {
        getPortfolio(
          true,
          !router.asPath.includes('portfolio') &&
            !router.asPath.includes('chartbit'),
        );
      } else if (isRealTrading && symbol) {
        getPortfolioDetail(symbol);
      }
      if (isVirtualTrading) getPortfolio(false);
    }
  }, [symbol, refetch]);

  return data || {};
};

export default useGetPortfolioData;
